import { InjectionToken } from '@angular/core';

export interface ContentfulConfig {
  spaceId: string;
  environment: string;
  deliveryToken: string;
  previewToken?: string;
  host?: string;
}

export const CONTENTFUL_CONFIG = new InjectionToken<ContentfulConfig>(
  'CONTENTFUL_CONFIG',
);
